module.exports = __webpack_public_path__ + "static/media/cartDetail.43bc7720.webp";